/**
 *  @class
 *  @function FacetsToggle
 */
class FacetToggle extends HTMLElement {

  constructor() {
    super();
    this.init();
  }
  init() {
    this.drawer = document.getElementById('Facet-Drawer');
    this.container = this.closest('.facets--bar-sticky');

    // Add functionality to buttons
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
    });
    if (this.container) {
      this.enableSticky();
    }

  }
  enableSticky() {
    let rootMargin = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 1;
    this.observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
      {
        threshold: [1],
        rootMargin: `-${rootMargin}px 0px 0px 0px`
      }
    );

    this.observer.observe(this.container);
  }

}
customElements.define('facet-toggle', FacetToggle);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.id === 'compare_toggle') {
        return;
      }
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }
 
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
 
        //new FacetsToggle(); 
$("[data-variants-grid-item]").each(function(){ 
//var column_width=Math.ceil($(this).width());
var column_width=Math.ceil($(this).find("product-card.product-card").width());
//$(this).find(".product_card_product .prod_card_imgs").css("width",column_width+'px');
var data_list=$(this).find(".card_slider").attr("data-list");
var slider_width=parseFloat(data_list)*parseFloat(column_width);
$(this).find(".card_slider").attr("data-count-sub",slider_width);
$(this).find(".card_slider").attr("data-count",column_width);
$(this).find(".prod_card_imgs").css({"width":column_width+'px',"height":column_width+'px'});
$(this).find(".prod_card_imgs .item").css({"width":column_width+'px',"height":column_width+'px'});
$(this).find(".card_slider").css({"width":slider_width+"px","transform":"translate3d(0px, 0px, 0px)"}); 
});
setTimeout(function(){
$(".product_card_product").removeClass("hide_blk");
},1000);
$("[data-variants-grid-item]").each(function(){
var sel_style=$(this).find("fieldset.product-form__inp .form_box .label.active").attr("style");
$(this).find("fieldset.product-form__inp .form__label span.form__label__value").attr("style",sel_style);
});


        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);


    
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function Facetremove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.compareToggle = this.querySelector('#compare_toggle');
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
    return false;
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);









$("[data-variants-grid-item]").each(function(){
//var column_width=Math.ceil($(this).width());
var column_width=Math.ceil($(this).find("product-card.product-card").width());
//$(this).find(".product_card_product .prod_card_imgs").css("width",column_width+'px');
var data_list=$(this).find(".card_slider").attr("data-list");
var slider_width=parseFloat(data_list)*parseFloat(column_width);
$(this).find(".card_slider").attr("data-count-sub",slider_width);
$(this).find(".card_slider").attr("data-count",column_width);
$(this).find(".prod_card_imgs").css({"width":column_width+'px',"height":column_width+'px'});
$(this).find(".prod_card_imgs .item").css({"width":column_width+'px',"height":column_width+'px'});
$(this).find(".card_slider").css({"width":slider_width+"px","transform":"translate3d(0px, 0px, 0px)"}); 
});




$(document).on("click", ".prod_card_imgs button.next", function () {
  const column = $(this).closest("li.column");
  const cardSlider = column.find(".card_slider");

  const dataCountSub = parseFloat(cardSlider.attr("data-count-sub"));
  const dataCount = parseFloat(cardSlider.attr("data-count"));
  const dataTrans = parseFloat(cardSlider.attr("data-trans"));

  // column.find(".prod_card_imgs button.prev").removeClass("disable");

  let addedCount = dataTrans + dataCount;

  if (addedCount < dataCountSub) {
    cardSlider.css({
      width: `${dataCountSub}px`,
      transform: `translate3d(-${addedCount}px, 0px, 0px)`
    });
    cardSlider.attr("data-trans", addedCount);
  } else {
    // Seamless scroll: continue from the start
    addedCount = addedCount - dataCountSub;
    cardSlider.css({
      width: `${dataCountSub}px`,
      transform: `translate3d(-${addedCount}px, 0px, 0px)`
    });
    cardSlider.attr("data-trans", addedCount);
  }
});

$(document).on("click", ".prod_card_imgs button.prev", function () {
  const column = $(this).closest("li.column");
  const cardSlider = column.find(".card_slider");

  const dataCountSub = parseFloat(cardSlider.attr("data-count-sub"));
  const dataCount = parseFloat(cardSlider.attr("data-count"));
  const dataTrans = parseFloat(cardSlider.attr("data-trans"));

  // column.find(".prod_card_imgs button.next").removeClass("disable");

  let addedCount = dataTrans - dataCount;

  if (addedCount >= 0) {
    cardSlider.css({
      width: `${dataCountSub}px`,
      transform: `translate3d(-${addedCount}px, 0px, 0px)`
    });
    cardSlider.attr("data-trans", addedCount);
  } else {
    // Seamless scroll: continue from the end
    addedCount = dataCountSub + addedCount;
    cardSlider.css({
      width: `${dataCountSub}px`,
      transform: `translate3d(-${addedCount}px, 0px, 0px)`
    });
    cardSlider.attr("data-trans", addedCount);
  }
});

$(document).on("click", ".product_card_product .variations fieldset .label", function() {
  const $this = $(this);
  const $productCard = $this.parents(".product_card_product");
  const $column = $this.parents("li.column");

  // Update the label values and active states
  const value = $this.attr("data-val");
  $this.parents("fieldset")
      .find(".form__label .form__label__value").html(value)
      .end()
      .find(".form__label").attr("data-val", value)
      .end()
      .find(".label").removeClass("active");
  $this.addClass("active");

  // Get selected variant combination
  const first = $this.parents("variant-selects").find(".variations fieldset:nth-child(1) .label.active").attr("data-val");
  const second = $this.parents("variant-selects").find(".variations fieldset:nth-child(2) .label.active").attr("data-val");
  const name = first + '/' + second;

  // Update variants list
  $productCard.find(".variants_list .list").removeClass("list_get");
  const $activeVariant = $productCard.find(`.variants_list .list[data-title='${name}']`).addClass("list_get");

  // Get variant ID and find corresponding slide
  const variantId = $activeVariant.attr("data-id");

  // Find Flickity instance
  const $slider = $column.find("slide-show");
  const flkty = Flickity.data($slider[0]);

  if (flkty) {
    // Find the slide index for this variant
    const slideIndex = Array.from(flkty.cells).findIndex(cell =>
        cell.element.getAttribute('data-id') === variantId
    );

    if (slideIndex !== -1) {
      // Select the slide
      flkty.select(slideIndex, false, true); // Select immediately without animation
    }
  }

  // Update add to cart button state
  const quantity = parseInt($activeVariant.attr("data-qnty"), 10);
  const $addToCartButton = $productCard.find(".variations .add_cart_pro");

  if (quantity > 0) {
    $addToCartButton
        .html("הוסף לעגלה")
        .removeClass("sold_pro");
  } else {
    $addToCartButton
        .html("אזל במלאי")
        .addClass("sold_pro");
  }
});

$(document).on("click",".product_card_product .variations fieldset.product-form__inp .label",function(){
var sel_style=$(this).parents("li.column").find("fieldset.product-form__inp .form_box .label.active").attr("style");
$(this).parents("li.column").find("fieldset.product-form__inp .form__label span.form__label__value").attr("style",sel_style);
});




$(document).on("mouseenter", ".product_card_product .variations fieldset .form__label", function() {
  // Cache common parent elements
  const $variations = $(this).parents(".variations");
  const $fieldset = $(this).parents("fieldset");
  const $productCard = $(this).parents(".product_card_product");

  // Handle variations and fieldset classes
  $variations.find("fieldset").removeClass("act_box");
  $fieldset.toggleClass("act_box");
  $variations.removeClass("act_boxs").toggleClass("act_boxs");

  const dataIndex = $fieldset.attr("data-index");
  console.log("Hovered option index:", dataIndex);

  // Handle option availability based on selection
  if (dataIndex === "option1" || dataIndex === "option2") {
    const isFirstOption = dataIndex === "option1";
    const otherOptionIndex = isFirstOption ? "option2" : "option1";

    // Get the value of the other option
    const otherOptionValue = $productCard
        .find(`.variations fieldset[data-index='${otherOptionIndex}'] .form__label`)
        .attr("data-val").replace(/ /g,'');

    // Target fieldset to update
    const $targetFieldset = $variations.find(`fieldset[data-index='${dataIndex}']`);

    // Clear previous sold out states
    $targetFieldset.find(".form_box .label").removeClass("opt_sold");

    // Check availability for each option
    $targetFieldset.find(".form_box .label").each(function() {
      const currentValue = $(this).attr("data-val").replace(/ /g,'');
      const variantName = isFirstOption
          ? `${currentValue}/${otherOptionValue}`
          : `${otherOptionValue}/${currentValue}`;

      const quantity = $productCard
          .find(`.variants_list .list[data-title='${variantName}']`)
          .attr("data-qnty");

      console.log(`Checking availability for ${variantName}:`, quantity);

      // Mark as sold out if undefined or 0 (for option2)
      const isSoldOut = isFirstOption
          ? quantity === undefined
          : quantity === undefined || quantity === "0";

      if (isSoldOut) {
        $(this).addClass("opt_sold");
      }
    });
  }
}).on("mouseleave", ".product_card_product .variations fieldset", function() {
  // Optional: Clean up on mouse leave
  const $variations = $(this).parents(".variations");

  // Remove active states when mouse leaves
  setTimeout(() => {
    if (!$variations.is(":hover")) {
      $variations.find("fieldset").removeClass("act_box");
      $variations.removeClass("act_boxs");
    }
  }, 100); // Small delay to prevent flickering
});

$(document).on("click",".variations fieldset span.count_inc",function(){
 
var data_sl=$(this).parents("li.column").find("fieldset.product-form__inp .form_box").attr("data-sl");
var data_mmm=$(this).parents("li.column").find("fieldset.product-form__inp .form_box").attr("data-mmm");
var data_slwidth=$(this).parents("li.column").find("fieldset.product-form__inp .form_box").attr("data-slwidth");
var data_one=$(this).parents("li.column").find("fieldset.product-form__inp .form_box").attr("data-one");
 
var data_slinc=parseFloat(data_sl)+parseFloat(1);
  
var data_one_ml=parseFloat(data_one)*parseFloat(data_slinc); 

console.log(data_sl);
console.log(data_mmm);
  
if(parseFloat(data_slinc)<parseFloat(data_mmm)){
$(this).parents("fieldset").find(".form_box").attr("data-sl",data_slinc);
$(this).parents("fieldset").find(".form_box").css({"width":data_slwidth+"px","transform":"translate3d(-"+data_one_ml+"px, 0px, 0px)"}); 


}
   
  
});

setTimeout(function(){
$(".product_card_product").removeClass("hide_blk");
},1000);

// $(document).on("click",".product_card_product .variations fieldset.act_box .form__label",function(){
// $(this).parents(".variations").find("fieldset").removeClass("act_box");
// $(this).parents(".variations").removeClass("act_boxs");
// });



$("[data-variants-grid-item]").each(function(){
var sel_style=$(this).find("fieldset.product-form__inp .form_box .label.active").attr("style");
$(this).find("fieldset.product-form__inp .form__label span.form__label__value").attr("style",sel_style);
// var v1=$(this).find(".variations fieldset:nth-child(1) .form__label").attr("data-val");
// var v2=$(this).find(".variations fieldset:nth-child(2) .form__label").attr("data-val");
// var name=v1+'/'+v2; 
// var qnt=$(this).find(".variants_list .list[data-title='"+name+"']").attr("data-qnty");
// console.log("xcxc : "+qnt);

var btn_qnty=parseFloat($(this).find(".product_card_product .variants_list .list.list_get").attr("data-qnty"));
if(btn_qnty>0){
  $(this).find(".product_card_product .variations .add_cart_pro").html("הוסף לעגלה");
  $(this).find(".product_card_product .variations .add_cart_pro").removeClass("sold_pro");
} else {
  $(this).find(".product_card_product .variations .add_cart_pro").html("אזל במלאי");
  $(this).find(".product_card_product .variations .add_cart_pro").addClass("sold_pro");
}
  
});


function cart_drawer(){
$.ajax({
type: 'GET', 
url: '/cart.js',
dataType: 'json',      
success:function(result){
  console.log(result);
  $("#CartDrawer").removeClass("is-empty");
  var items = result['items']; 
  var item_count = result['item_count'];
  var cart_price = result['items_subtotal_price'];
  var subtotal_price = parseFloat(cart_price/100);
  var cart_full="";  
  var count=1;
  for (var i=0;i<items.length;i++){
    var image = items[i]['image'];
    var key = items[i]['key'];
    var title = items[i]['product_title'];
    var variant_id = items[i]['variant_id']; 
    var var_title = items[i]['title']; 
    var url = items[i]['url'];    
    var price = items[i]['final_price'];
    var quantity = items[i]['quantity'];
    var id = items[i]['id'];
    var selling_plan = items[i]['selling_plan_allocation'];  
    if(selling_plan==undefined){
     var selling_plan_name = " "; 
    } else {
     var selling_plan_name = '<div class="cart__item--variants">'+selling_plan['selling_plan']['name']+'</div>'; 
    }
    var var_price = parseFloat(price/100);  
var pro_title='<a href="'+url+'" title="'+title+'" class="cart-product-link">'+title+'</a>';
var pro_price='<span class="price"><ins><span class="amount">₪'+var_price+'</span></ins></span>'; 
var pro_opt='<div class="product-cart-item-options">'+var_title+'</div>'; 

var plus_svg='<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5H9" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 1V9" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
 

var minus_svg='<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H7" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
var minus='<button class="minus disabled" type="button" aria-label="Decrease quantity for '+title+'">'+minus_svg+'</button>';
var input='<input type="number" name="updates[]" id="'+key+'" value="'+quantity+'" min="1" max="9999" step="1" class="qty" data-index="2" aria-label="Quantity for '+title+'">';
var plus='<button class="plus" type="button" aria-label="Increase quantity for '+title+'">'+plus_svg+'</button>';
    
var quantity_selector='<quantity-selector class="quantity cart-update small-qty buttons_added" data-id="'+key+'">'+minus+input+plus+'</quantity-selector>';

var delete_svg='<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3L1 3M5.00024 6V10M8.00024 6V10M11.0002 3V12.5C11.0002 12.6326 10.9476 12.7598 10.8538 12.8536C10.76 12.9473 10.6329 13 10.5002 13H2.50024C2.36764 13 2.24046 12.9473 2.14669 12.8536C2.05292 12.7598 2.00024 12.6326 2.00024 12.5V3M9.00025 3V2C9.00025 1.73478 8.89489 1.48043 8.70735 1.29289C8.51982 1.10536 8.26546 1 8.00024 1H5.00024C4.73503 1 4.48067 1.10536 4.29314 1.29289C4.1056 1.48043 4.00024 1.73478 4.00024 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
var pro_delete='<a href="/cart/change?line='+count+'&amp;quantity=0" data-val="'+variant_id+'" class="remove pro_rm" data-index="'+count+'">'+delete_svg+'</a>';

    
var cart_image='<div class="product-cart-item-image"><img src="'+image+'" /></div>';
var cart_info='<div class="product-cart-item-info">'+pro_title+pro_price+pro_opt+quantity_selector+pro_delete+'</div>';
var cart_price='<div class="product-cart-item-price"><span class="price"><ins><span class="amount">₪'+var_price+'</span></ins></span></div>';
    
    
    var product_item='<div class="product-cart-item" id="CartDrawerItem-'+count+'">'+cart_image+cart_info+cart_price+'</div>';
   
    cart_full=cart_full+product_item;
    count++;
  }
$("#Cart-Drawer .side-panel-content").html('<div class="product-cart-item--container">'+cart_full+'</div>');
$("#Cart-Drawer .side-panel-header span sup").html(item_count);
$("#cart-drawer-toggle span.thb-item-count").html(item_count);
if(count==2){
$(".cart-drawer .side-panel-inner .side-panel-footer").remove();
var th='<th>Total<p class="cart-policy-text">Taxes and shipping calculated at checkout</p></th>';
var td='<td><span class="price"><span class="amount">₪'+subtotal_price+'</span></span></td>';
var table='<table class="collaterals"><tbody><tr class="cart-total">'+th+td+'</tr></tbody></table>';
var drawer_buttons='<div class="cart-drawer-buttons"><form action="/cart" method="post" novalidate=""><button type="submit" class="button accent checkout full" name="checkout" title="Checkout"><span>Checkout</span></button></form></div>';
var drawer_footer='<div class="side-panel-footer"><div class="cart-drawer-footer">'+table+drawer_buttons+'</div></div>';
$(".cart-drawer .side-panel-inner").append(drawer_footer);
}
if(item_count==0){
var empty_svg='<svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M63.2133 82.0001C58.4983 82.0001 54.6765 78.1637 54.6765 73.4633C54.6765 68.7483 58.5129 64.9265 63.2133 64.9265C67.9137 64.9265 71.7501 68.7629 71.7501 73.4633C71.7501 78.1637 67.9137 82.0001 63.2133 82.0001ZM63.2133 68.3383C60.3872 68.3383 58.0883 70.6372 58.0883 73.4633C58.0883 76.2894 60.3872 78.5883 63.2133 78.5883C66.0394 78.5883 68.3383 76.2894 68.3383 73.4633C68.3383 70.6372 66.0394 68.3383 63.2133 68.3383Z" fill="var(--color-accent)"></path><path d="M29.0368 82.0001C24.3218 82.0001 20.5 78.1637 20.5 73.4633C20.5 68.7483 24.3364 64.9265 29.0368 64.9265C33.7372 64.9265 37.5736 68.7629 37.5736 73.4633C37.5882 78.1637 33.7518 82.0001 29.0368 82.0001ZM29.0368 68.3383C26.2107 68.3383 23.9118 70.6372 23.9118 73.4633C23.9118 76.2894 26.2107 78.5883 29.0368 78.5883C31.8629 78.5883 34.1618 76.2894 34.1618 73.4633C34.1618 70.6372 31.8629 68.3383 29.0368 68.3383Z" fill="var(--color-accent)"></path><path d="M70.0368 61.4999H30.6036C24.9221 61.4999 20.0021 57.4585 18.8746 51.8942L10.5575 10.2499H1.71321C0.761429 10.2499 0 9.48849 0 8.5367C0 7.59956 0.761429 6.82349 1.71321 6.82349H11.9632C12.7832 6.82349 13.4714 7.39456 13.6325 8.19991L22.2425 51.206C23.0332 55.1888 26.5621 58.0735 30.6182 58.0735H70.0514C70.9886 58.0735 71.7646 58.8349 71.7646 59.7867C71.75 60.7385 70.9886 61.4999 70.0368 61.4999Z" fill="var(--color-accent)"></path><path d="M67.4304 47.8383H20.5001C19.5629 47.8383 18.7869 47.0768 18.7869 46.125C18.7869 45.1733 19.5483 44.4118 20.5001 44.4118H67.4304C70.0076 44.4118 72.204 42.479 72.5115 39.9165C72.6286 38.9793 73.5365 38.3204 74.4151 38.4376C75.3522 38.5547 76.0111 39.404 75.894 40.3411C75.3668 44.6168 71.7208 47.8383 67.4304 47.8383Z" fill="var(--color-accent)"></path><path d="M39.2869 20.4999H15.3751C14.4379 20.4999 13.6619 19.7385 13.6619 18.7867C13.6619 17.8496 14.4233 17.0735 15.3751 17.0735H39.2869C40.224 17.0735 41.0001 17.8349 41.0001 18.7867C41.0001 19.7385 40.2386 20.4999 39.2869 20.4999Z" fill="var(--color-accent)"></path><path d="M63.2133 37.5882C52.8608 37.5882 44.4265 29.1539 44.4265 18.8014C44.4265 8.44893 52.8462 0 63.2133 0C73.5658 0 82.0001 8.43429 82.0001 18.7868C82.0001 29.1393 73.5658 37.5882 63.2133 37.5882ZM63.2133 3.41179C54.7351 3.41179 47.8383 10.3086 47.8383 18.7868C47.8383 27.265 54.7351 34.1618 63.2133 34.1618C71.6915 34.1618 78.5883 27.265 78.5883 18.7868C78.5883 10.3086 71.6915 3.41179 63.2133 3.41179Z" fill="var(--color-accent)"></path><path d="M70.0368 27.3382C69.5976 27.3382 69.1583 27.1771 68.8215 26.8404L55.1597 13.1786C54.4861 12.505 54.4861 11.4361 55.1597 10.7625C55.8333 10.0889 56.9022 10.0889 57.5758 10.7625L71.2376 24.4243C71.9111 25.0979 71.9111 26.1668 71.2376 26.8404C70.9154 27.1625 70.4761 27.3382 70.0368 27.3382Z" fill="var(--color-accent)"></path><path d="M56.3751 27.3382C55.9358 27.3382 55.4965 27.1771 55.1597 26.8404C54.4861 26.1668 54.4861 25.0979 55.1597 24.4243L68.8215 10.7625C69.4951 10.0889 70.564 10.0889 71.2376 10.7625C71.9111 11.4361 71.9111 12.505 71.2376 13.1786L57.5758 26.8404C57.2536 27.1625 56.8144 27.3382 56.3751 27.3382Z" fill="var(--color-accent)"></path></svg>';
var empty_content=' <div class="cart-drawer__empty-cart">'+empty_svg+'<p>Your cart is currently empty.</p><a class="button accent2" href="/collections/all"><span>Start Shopping</span></a></div>';
  $(".cart-drawer .side-panel-content").html(empty_content);
}
},
error: function(perror_cart){
	console.log(perror_cart);
} 
   }); 
}






$(document).on("click","#Cart-Drawer .product-cart-item--container .product-cart-item a.remove.pro_rm",function(e){
e.preventDefault();
  console.log("Remove!");
var pro_var=$(this).attr("data-val");
  console.log("pro_var : "+pro_var);
  
var productQty=0;  
var var_id = {
id: pro_var,
quantity: productQty
}   
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data:var_id,
      success: function(result){
        console.log(result);
        cart_drawer();
      },
      error: function(result_cart){
        console.log(result_cart);
      }
  });
  
 
     
});




$(document).on("click",".product_card_product variant-selects .variations span.add_cart_pro",function(){
var pro_var=$(this).parents("li.column").find(".variants_list .list.list_get").attr("data-id");
var productQty=1;  
var var_id = {
id: pro_var,
quantity: productQty
}   
  $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: var_id,
    success:function(result){
      cart_drawer();
          document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

     //   dispatchCustomEvent('cart-drawer:open');
 
console.log(result);
    } ,
error: function(cart_add){
console.log(cart_add);
}
   });
     
});
